<h2 mat-dialog-title class="tw-m-0 tw-text-lg tw-font-semibold">Transactions from source</h2>
<div
  appGlossScroll
  mat-dialog-content
  class="tw-max-h-[70vh] tw-overflow-y-auto tw-min-w-[min(90vw,36rem)]"
>
  <p class="tw-text-sm tw-text-dt-text-secondary tw-m-0 tw-mb-3">
    srId:
    <span class="tw-font-mono tw-break-all">{{ data.srIdLabel }}</span>
    · {{ data.transactions.length }} in app store
  </p>
  @for (tx of data.transactions; track tx.id) {
    <div class="tw-mb-6 tw-last:tw-mb-0">
      <div class="tw-text-xs tw-font-mono tw-text-dt-text-secondary tw-mb-2">
        id: {{ tx.id }} · {{ tx.description ?? "—" }} ·
        {{ tx.glossPostDate?.dateString ?? "—" }}
      </div>
      <pre
        appGlossScroll
        class="tw-m-0 tw-text-xs tw-font-mono tw-max-h-48 tw-overflow-auto tw-p-3 tw-bg-neutral-900 tw-text-dt-text-disabled tw-rounded tw-whitespace-pre-wrap tw-break-words gs-dark"
        >{{ txJson(tx) }}</pre
      >
    </div>
  }
  @if (data.transactions.length === 0) {
    <p class="tw-text-sm tw-text-dt-text-tertiary tw-m-0">
      No matching transactions in the app store.
    </p>
  }
</div>
<div mat-dialog-actions class="tw-flex tw-justify-end tw-gap-2">
  <button mat-button mat-dialog-close type="button">Close</button>
</div>
